<template>
  <div>
    <section class="section">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <hero-bar :has-right-visible="true"> <b-icon icon="mdi mdi-bank" type="is-primary" size="is-medium"></b-icon> Bank Details </hero-bar>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link :to="{ name: 'SaveBankDetails' }" class="button is-info is-small btnicon" title="Add"> Add Details </router-link>
          </div>
          <!-- <div class="level-item">
            <a class="button is-small is-link" @click="enableFilterModal = !enableFilterModal" title="Filter">
              <b-icon icon="filter" size="is-small"></b-icon>
            </a>
          </div> -->
        </div>
      </div>
      Total Records :
      <b>{{ this.total }}</b>
    </section>

    <section class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="bankinfo || []" style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column field="name" label="Account No" sortable>{{ props.row && props.row.accountNo ? props.row.accountNo : '' }}</b-table-column>
            <b-table-column field="priority" label="Bank Name" sortable>{{ props.row && props.row.bankName ? props.row.bankName : '' }} </b-table-column>
            <b-table-column field="level" label="Beneficiary Name" sortable>{{ props.row && props.row.beneficiaryName ? props.row.beneficiaryName : '' }} </b-table-column>
            <b-table-column label="Status" field="isActive" sortable centered>
              <span v-bind:class="tag[props.row.isActive]" class="is-medium is-capitalized">{{ props.row.isActive ? 'Active' : 'Deactive' }}</span>
            </b-table-column>
            <b-table-column field="classes" label="Franchisee" sortable>
              <b-tag type="is-success">{{ props.row && props.row.franchisee ? props.row.franchisee.companyName : '' }}</b-tag></b-table-column
            >

            <b-table-column field="classes" label="Bank Branch" sortable> {{ props.row && props.row.bankBranchName ? props.row.bankBranchName : '' }}</b-table-column>
            <b-table-column field="classes" label="IFSC" sortable> {{ props.row && props.row.ifscCode ? props.row.ifscCode : '' }}</b-table-column>
            <b-table-column field="classes" label="Razor pay AccountID" sortable> {{ props.row && props.row.razorpayAccountID ? props.row.razorpayAccountID : '' }}</b-table-column>

            <b-table-column field="name" label="Short Name" sortable>{{ props.row && props.row.shortName ? props.row.shortName : '' }}</b-table-column>

            <b-table-column label="Action" centered>
              <div class="buttons">
                <router-link :to="{ name: 'EditBankDetails', params: { id: props.row.id } }" class="button is-info is-small btnicon" title="Edit">
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
                <!-- <button class="button is-small is-primary" type="button" @click="viewMore(props.row)" title="View More..">
                  <b-icon icon="eye" size="is-small" />
                </button> -->
                <!-- <button class="button is-small is-danger" type="button" @click.prevent="deleteFee(props.row.id)" title="Delete..">
                  <b-icon icon="trash-can" size="is-small" />
                </button> -->
              </div>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nothing here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import HeroBar from '@/components/template/HeroBar'

export default {
  name: 'FeeTypeList',
  components: {
    CardComponent,
    HeroBar
  },
  data () {
    return {
      bankinfo: [],
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      enableFilterModal: false,
      viewMoreData: [],
      tag: {
        true: 'has-text-info',
        false: 'has-text-danger'
      }
    }
  },
  created () {
    this.getbankList()
  },
  methods: {
    getbankList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/franchisee-bank-details`)

        this.bankinfo = response ? response.data : []

        if (!this.bankinfo) {
          this.total = 0
        } else {
          this.total = this.bankinfo.length
        }

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
<style scoped>
.buttons {
  flex-wrap: nowrap;
}
</style>
